import { render, staticRenderFns } from "./mainItem.vue?vue&type=template&id=956bf90e&scoped=true&"
import script from "./mainItem.vue?vue&type=script&lang=js&"
export * from "./mainItem.vue?vue&type=script&lang=js&"
import style0 from "./mainItem.vue?vue&type=style&index=0&id=956bf90e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956bf90e",
  null
  
)

export default component.exports